import React from 'react';
import { Switch, Route/*, Redirect*/ } from "react-router-dom";
import { useDispatch } from 'react-redux';

import DiscoverManager from '../custom/-APP_TARGET/content/DiscoverManager';

import { setAuth } from "../../../actions/index";

function MainRoute() {
  const dispatch = useDispatch();
  return (
    <Switch>
      <Route exact path={[`/`, '/home']} render={ props => {
        if (props.location.search.includes('?code=')) { 
          const code = props.location.search.replace('?code=', '')
          dispatch(setAuth({ code }));
        }
        return <DiscoverManager />
      } } />
      <Route path={'/home'}>
        <DiscoverManager />
      </Route>
      <Route path={'/new-account'} render={ props => {
        localStorage.setItem('new_account', 'true');
        if (props.location.search.includes('?code=')) { 
          const code = props.location.search.replace('?code=', '')
          dispatch(setAuth({ code }));
        }
        return <DiscoverManager />
      } } />
    </Switch>
  );
}

export default MainRoute;
